import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { Text } from '@perch-labs/shrike';

export const StyledSVG = styled(SVG).attrs({
  height: '32px',
  width: '32px',
})<StyleProps>`
  ${props => props.theme.media.small`
  height: 24px;
  width: 24px;
  display: 'auto';
`}
`;

export const StyledText = styled(Text)`
  max-width: 70%;

  ${props => props.theme.media.small`
    max-width: 100%;
  `}
`;
